import React from "react";

function SvgIcMapJunction(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M7.884 17.769l4.24-3.778 4.253 3.765c.38.337.915.3 1.257-.087l2.273-2.573c.056-.06.106-.225.09-.417-.013-.154-.064-.259-.096-.283l-4.428-3.343 2.848-2.497c.045-.041.105-.193.093-.402-.01-.175-.066-.282-.094-.302l-2.318-1.537c-.31-.206-.695-.195-.997.029L12.09 8.499 9.02 6.181c-.296-.223-.677-.242-.987-.045L5.707 7.604c-.02.012-.08.106-.094.289-.012.193.038.364.096.414l2.984 2.645-4.595 3.317c-.025.018-.08.11-.095.281-.016.195.033.358.09.42l2.55 2.734c.346.369.87.396 1.241.065"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapJunction;
